import { replaceLinks } from "./replace-urls";

export function mapCards(cards) {
  return cards.map((card) => {
    if (!card.acf) return;

    const acf = JSON.parse(card.acf);

    const isPopup = !!acf.modal_description;
    const postType = card.contentTypeName;
    const title = card.title;
    let htmlTag = "a";
    let linkUrl = undefined;
    let linkTarget = undefined;
    let externalCard = acf.external_card;
    if (!isPopup) {
      if (externalCard === true) {
        linkUrl = acf.link_url?.url;
        linkTarget = acf.link_url?.target;
      } else if (acf.link_url?.url) {
        linkUrl = card.link;
        linkTarget = "_self";
      } else if (postType === "lw_news") {
        linkUrl = acf?.link;
        linkTarget = "_blank";
      } else if (postType === "awards") {
        htmlTag = "div";
      } else {
        linkUrl = card.link;
      }
    } else {
      htmlTag = "div";
    }

    let cardImage = acf?.resources_image || card.featuredImage?.node?.sourceUrl;

    const date =
      card.date &&
      (postType === "post" ||
        postType === "lw_news" ||
        postType === "lw_press") &&
      new Date(card.date).toLocaleDateString("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric",
      });

    const taxonomies = card.taxonomies
      ? JSON.parse(card.taxonomies)
      : undefined;
    return {
      id: card.id,
      resourceType: card.resourceType,
      htmlTag,
      acf,
      isVideo: false,
      isPopup,
      linkUrl: replaceLinks(linkUrl),
      linkTarget,
      cardImage,
      date,
      title,
      postType,
      categories: card.categories ? JSON.parse(card.categories) : [],
      terms: card?.terms?.nodes,
      taxonomies,
    };
  });
}

function isResourceVideo(acf, resourceType) {
  if (resourceType?.slug === "video" && acf.video_provider && acf.video_id) {
    return true;
  } else {
    return false;
  }
}
